module.exports = __webpack_public_path__ + "img/g10.a2fbd92c.jpg";